<template>
  <div
    ref="root"
    class="notification-bell"
    :class="[
      `notification-bell--${variant}`,
      { 'notification-bell--has-notifications': hasUnread },
    ]"
    @click.stop="$emit('click', $event)"
  >
    <font-awesome-icon
      :icon="faBellOutline"
      class="notification-bell__icon"
    />
    <span
      v-if="hasUnread"
      class="notification-bell__dot"
      aria-hidden="true"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faBell as faBellOutline } from '@fortawesome/free-regular-svg-icons/faBell';

defineProps({
  hasUnread: { type: Boolean, default: false },
  variant: {
    type: String,
    default: 'header',
    validator: (value) => ['header', 'home'].includes(value),
  },
});

defineEmits(['click']);

const root = ref(null);

defineExpose({
  getBoundingClientRect: () => root.value?.getBoundingClientRect() ?? null,
});
</script>

<style lang="scss" scoped>
@use 'sass:map';
@use '@/scss/tokens.scss' as main;

.notification-bell {
  position: relative;
  margin: 0;
  display: flex;
  align-items: center;

  &__icon {
    transition: color 0.2s ease, opacity 0.2s ease;
  }

  &--header &__icon {
    font-size: 1.1rem;
    color: #969ccb;
  }

  &--home &__icon {
    font-size: 1.1rem;
    color: var(--grey-2500, #666);
  }

  &--has-notifications &__icon {
    color: main.$color-primary;
  }

  [theme='night'] &--has-notifications &__icon {
    color: #ffffff;
  }

  &__dot {
    position: absolute;
    top: -2px;
    right: -2px;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: #ffffff;
    box-shadow: 0 0 0 1px main.$color-primary;
    pointer-events: none;
  }

  [theme='night'] &__dot {
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.55);
  }

  &:hover {
    cursor: pointer;
  }

  &--header:hover &__icon {
    color: #343b86;
  }

  &--home:hover &__icon {
    color: main.$color-primary;
  }

  [theme='night'] &--header:hover &__icon {
    color: #ffffff;
  }

  @media screen and (min-width: map.get(main.$grid-breakpoints, md)) {
    margin-right: 0;
  }
}
</style>
